import { WildNavigationType } from "src/data/enums/navigation_type";
import { FeaturesComponentListData } from "../FeaturesData";

export const wildProListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/misc%2Fwildlogo.png?alt=media&token=87b004dd-dd18-4815-a240-0f049dfc787b",
  title: "Wild Pro",
  subtitle: "Take your Watersports to the Next Level",
  page: WildNavigationType.WILDPRO,
}